import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Row } from 'reactstrap';
import { Header } from './Header';
import { Repository } from './Repository';
export const RepositoryList = ({ repos, selectedRepos, user, onToggleItem, onRegisterWebhook, onToggleItems }) => {
    const items = [];
    let sectionTitle = repos.length > 0 ? repos[0].label.substring(0, repos[0].label.lastIndexOf('/')) : '';
    let section = [];
    let sectionIds = [];
    for (const repo of repos) {
        const lastIndexOf = repo.label.lastIndexOf('/');
        const title = repo.label.substring(0, lastIndexOf);
        if (title !== sectionTitle) {
            items.push(_jsx(Header, { title: sectionTitle, ids: sectionIds, selectedRepos: selectedRepos, onToggleItems: onToggleItems }, sectionTitle + '-header'), _jsx(Row, { children: section }, sectionTitle + '-section'));
            section = [];
            sectionIds = [];
        }
        const options = {
            ...repo,
            label: repo.label.substring(lastIndexOf + 1),
        };
        section.push(_jsx(Repository, { option: options, user: user, isSelected: selectedRepos.includes(repo.value), onToggleItem: onToggleItem, onRegisterWebhook: onRegisterWebhook }));
        sectionIds.push(repo.value);
        sectionTitle = title;
    }
    if (sectionTitle !== '') {
        items.push(_jsx(Header, { title: sectionTitle, ids: sectionIds, selectedRepos: selectedRepos, onToggleItems: onToggleItems }, sectionTitle + '-header'), _jsx(Row, { children: section }, sectionTitle + '-section'));
    }
    return _jsx(_Fragment, { children: items });
};
